// src/service/translate/trains/trainTranslations.nl-NL.ts
import type { TrainTranslations } from "./trainTranslations.types";

const trainNlTranslations: TrainTranslations = {
    trainPage: {
        title: "Trein",
        step: "Stap",
        resultsFound: "treinopties gevonden",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Volgende stap",
        loadingTimeline: "Dienstregeling laden…",
    },
    widgetBreadcrumbs: {
        home: "Home",
        summary: "Overzicht",
        contact: "Contactgegevens",
        payment: "Betaling",
    },
    trainSortBy: {
        title: "Sorteren op",
        price_asc: "Laagste prijs eerst",
        price_desc: "Hoogste prijs eerst",
        fastest: "Snelste",
        fewest_changes: "Minste overstappen"
    },
    trainBlock: {
        title: "Treindienst",
        direct: "Direct",
    },
    trainFilters: {
        outboundTrip: {
            title: "Vertrektijden heenreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "Bestemmingsstation",
                time: "Aankomst"
            }
        },
        inboundTrip: {
            title: "Vertrektijden terugreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "",
                time: "Aankomst"
            }
        },
        operators: "Vervoerder",
        duration: "Reisduur"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille",
        PLY: "Parijs - Gare de Lyon",
        PAZ: "Parijs Gare d’Austerlitz",
        PEST: "Parijs - Gare de l'Est",
        PARIS: "Parijs - Gare de Lyon",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerpen",
        BRU: "Brussel-Zuid",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        TNE: "Travelski Night Express",
        PEG: "Travelski Night Express",
        PEGASUS: "Travelski Night Express",
    },
    trainClass: {
        standard: "Standaard",
        premium: "Eerste klasse",
        title: "Reistypen",
        outOfStock: "Uitverkocht"
    },
    trainClassCard: {
        yourTrain: "Uw trein",
        travelClass: "Uw reisklasse",
        details: "Details",
        from: "Vanaf",
        included: "Inbegrepen",
        select: "Selecteren",
        classes: {
            seat: {
                title: "Zitplaatsen",
                description: "Comfortabele zitplaats voor een voordelige reis (stoelen kunnen niet achterover worden geklapt).",
            },
            standard: {
                title: "Standaard",
                description: "Standaard ligplaats met alles wat je nodig hebt voor de reis.",
            },
            standardPlus: {
                title: "Standaard plus",
                description: "Standaard ligplaats met alles wat je nodig hebt voor de reis.",
            },
            premiere: {
                title: "Eerste klasse",
                description: "De premium reisoptie voor een comfortabele reis",
            },
        },
        criteria: {
            compartment6: "Coupé 6 stoelen",
            compartment4: "Slaapcoupé 4 personen",
            compartment3: "Slaapcoupé 3 personen",
            nonRecliningSeats: "Niet-verstelbare stoelen",
            electricalOutlet: "Elektrisch stopcontact",
            breakfastOptional: "Optie: ontbijt",
            sleepingBagSheet: "Lakenzak, kussensloop en deken inbegrepen.",
            storageSpace: "Opbergruimte",
            comfortMattress: "Comfortabele topmatras.",
            sheetDuvetPillow: "Laken, dekbed en kussensloop inbegrepen.",
            storageNet: "Opbergnet",
            blackoutBlind: "Verduisteringsgordijn",
            realBeds: "Echte bedden, voorzien met lakens, deken en kussensloop.",
            premiumBedding: "Premium beddengoed",
            loungeSeats3: "3 zitplaatsen",
            connectingCompartments: "Mogelijkheid tot verbindingsdeuren tussen coupés",
            privateSink: "Privé wastafel",
            largeStorage: "Grote opbergruimte",
            welcomeKit: "Welkomstpakket",
        },
        subOptions: {
            individualBerths: {
                title: "2 individuele ligplaatsen",
                description: "Beleef een unieke ervaring tijdens de reis in een gedeelde cabine voor 6 personen.",
            },
            privateCompartment: {
                title: "Privécoupé 6 ligplaatsen",
                description: "Privatiseer de coupé, alléén of met meerdere personen, voor je gezinsreis of met vrienden",
            },
            privateCompartmentStandardPlus: {
                title: "Privécoupé 6 ligplaatsen",
                description: "Privatiseer de coupé, alleen of met meerdere personen, voor je gezinsreis of met vrienden",
            },
            privateCompartmentStandardPlus4: {
                title: "Privécoupé 4 ligplaatsen",
                description: "Privatiseer de coupé, alleen of met meerdere personen, voor je gezinsreis of met vrienden",
            },
            privateCompartmentPremiere: {
                title: "Privécoupé 3 ligplaatsen",
                description: "Privatiseer de coupé, alleen of met meerdere personen, voor je gezinsreis of met vrienden.",
            },
            seat: {
                title: "Zitplaatsen",
                description: "Zitplaats ideaal voor een voordelige reis (niet-verstelbare stoelen).",
            },
        },
        modal: {
            serviceTitle: "Service",
            services: {
                seat: {
                    breakfastOptional: "Ontbijt optioneel",
                },
                standard: {
                    breakfastOptional: "Ontbijt optioneel",
                },
                standardPlus: {
                    breakfastOptional: "Ontbijt optioneel",
                    comfortKit: "Comfortkits: matrasbeschermer + dekbed (€5,50/pers)",
                },
                premiere: {
                    breakfastOptional: "Ontbijt optioneel",
                },
            },
        },
    }
};

export default trainNlTranslations;
